const recentLogs = new Map();
const LOG_THRESHOLD = 1000; // 1 secondo tra log identici

export const debugLog = (...args) => {
  if (process.env.NODE_ENV !== 'development') {
    return; // Non logga in produzione
  }
  
  // Crea una chiave basata sul primo argomento (solitamente il messaggio)
  const key = String(args[0]);
  
  // Controlla se abbiamo registrato questo log di recente
  const now = Date.now();
  const lastLogTime = recentLogs.get(key);
  
  if (lastLogTime && (now - lastLogTime) < LOG_THRESHOLD) {
    // Log troppo recente, ignoralo per evitare spam
    return;
  }
  
  // Registra il timestamp di questo log
  recentLogs.set(key, now);
  
  // Limita la dimensione della mappa per evitare memory leak
  if (recentLogs.size > 100) {
    // Rimuovi le voci più vecchie
    const oldestKeys = [...recentLogs.entries()]
      .sort((a, b) => a[1] - b[1])
      .slice(0, 50)
      .map(entry => entry[0]);
    
    oldestKeys.forEach(key => recentLogs.delete(key));
  }
  
  // Esegui il log effettivo
  console.log(...args);
};